module.exports = __webpack_public_path__ + "static/media/011.b3deac61.jpg";